
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators, FormGroup, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-save-as-dialog',
  templateUrl: './save-as-dialog.component.html',
  styleUrls: ['./save-as-dialog.component.css']
})
export class SaveAsDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
      private fb: FormBuilder,
      private dialogRef: MatDialogRef<SaveAsDialogComponent>) {
      
      this.form = fb.group({
        newTemplateName: [ '', [ Validators.required ] ]
      });
  }

  ngOnInit() {
  }

  get newTemplateName() { return this.form.get('newTemplateName'); }    

  save() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  close() {
      this.dialogRef.close();
  }

}
